var XPortal = XPortal || {};
XPortal.GRecaptcha = (function () {
    const isDarkTheme = document.body.classList.contains('theme-dark');
    const rcTheme = isDarkTheme ? 'dark' : 'light';
    var self = {
        InitJQueryValidators: function () {
            jQuery.validator.addMethod('grecaptcha', function (value, element, params) {
                let modelName = XPortal.Store.getModelName($(this.currentForm).closest(XPortal.Main.DetialFormSelector).attr("id"));
                if (modelName == null || !modelName.length) return false;
                let version = $("[data-val-grecaptcha]").data() != null ? $("[data-val-grecaptcha]").attr("data-val-grecaptcha-ver") : "";
                if (version == "V2")
                    return IsCaptchaV2Checked(element, modelName);
                else if (version == "V3")
                    return IsCaptchaV3Checked(element, modelName);
            });
            $.validator.unobtrusive.adapters.addBool('grecaptcha');
        },
        RenderGRecaptcha: function () {
            let gReCaptchaInfo = $("[data-val-grecaptcha]");
            if (gReCaptchaInfo != null && gReCaptchaInfo.length) {
                let version = gReCaptchaInfo.attr("data-val-grecaptcha-ver");
                if (version == "V2")
                    XPortal.GRecaptcha.RenderGRecaptchaV2(gReCaptchaInfo);
                if (version == "V3")
                    XPortal.GRecaptcha.RenderGRecaptchaV3(gReCaptchaInfo);
            }
        },
        RenderGRecaptchaV2: function (gReCaptchaInfo) {
            if ($("#g-recaptchaV2").length) return;
            $(".content-wrapper").append($('<div/>', {
                id: 'g-recaptchaV2',
                class: 'g-recaptcha',
                'data-theme': rcTheme
            }));
            let gReCaptchaV2 = $("#g-recaptchaV2");
            gReCaptchaV2.data('sitekey', gReCaptchaInfo.attr("data-val-grecaptcha-sitekey"));
            gReCaptchaV2.data('validation-message', gReCaptchaInfo.attr("data-val-grecaptcha-msg"));
            let srt = $('<script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit"async defer></script>').appendTo($(".content-wrapper"));
            gReCaptchaInfo.closest('.field-cntr').hide();
            gReCaptchaInfo.closest('.field-cntr').after($("#g-recaptchaV2"));
        },
        RenderGRecaptchaV3: function (gReCaptchaInfo) {
            if ($("#g-recaptchaV3").length) return;
            let publicSiteKey = gReCaptchaInfo.attr("data-val-grecaptcha-sitekey");
            $('<script id="g-recaptchaV3" src="https://www.google.com/recaptcha/api.js?onload=onloadCallbacV3&render=' + publicSiteKey + '"></' + 'script>').appendTo(document.body);
            gReCaptchaInfo.closest('.field-cntr').hide();
        }
    };
    return self;
}());
//v2
var onloadCallback = function () {
    grecaptcha.render('g-recaptchaV2', {
        'sitekey': $("[data-val-grecaptcha]").attr("data-val-grecaptcha-sitekey")
    });
};

function IsCaptchaV2Checked(element, modelName) {
    var isValid = grecaptcha && grecaptcha.getResponse().length !== 0;
    if (isValid) {
        getGRecaptchaResponse(element, modelName);
        return isValid;
    }
    return isValid;
}

function getGRecaptchaResponse(element, modelName) {
    var token = grecaptcha.getResponse();
    var gRecaptchaEl = $("[data-val-grecaptcha]");
    return SetGReCaptchaFieldValue(token, element, modelName, gRecaptchaEl);
}

//V3
var onloadCallbacV3 = function () {
    let publicSiteKey = $("[data-val-grecaptcha]").attr("data-val-grecaptcha-sitekey");
    var interval = setInterval(function () {
        if (window.grecaptcha) {
            grecaptcha.ready(function () {
                grecaptcha.execute(publicSiteKey, { action: 'HandleSavedData' }).then(function (token) {
                    $("[data-val-grecaptcha]").attr("data-store-val", token);
                });
            });
            clearInterval(interval);
        }
    }, 1000);
};

function IsCaptchaV3Checked(element, modelName) {
    var gRecaptchaEl = $("[data-val-grecaptcha]");
    if (gRecaptchaEl == null) return false;
    let token = gRecaptchaEl.attr("data-store-val");
    return SetGReCaptchaFieldValue(token, element, modelName, gRecaptchaEl);
}

function SetGReCaptchaFieldValue(token, element, modelName, gRecaptchaEl) {
    if (token == null || gRecaptchaEl == null) return false;
    let fieldName = XPortal.Main.GetSettingsFor($(element)).meta.fieldname;
    if (fieldName == null) return false;
    XPortal.Store.DispatchByName(modelName, fieldName, token, true);
    return true;
}